var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGrammar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.5414 24.8254C27.3875 18.1567 33.0905 13 40 13C46.9183 13 52.6271 18.1699 53.4618 24.8511C56.6804 24.9772 59.1156 25.335 61.1654 26.4648C62.9198 27.4317 64.4259 28.7678 65.5881 30.3663C64.7263 31.2057 63.81 32.1099 63.7174 32.2023L55.1463 40.7593C51.1785 44.7206 48.3259 47.5632 45.8654 49.4374C43.4458 51.2804 41.6146 52.0197 39.7138 52.0197C37.813 52.0197 35.9817 51.2804 33.5621 49.4374C31.1016 47.5632 28.249 44.7206 24.2813 40.7593L14.1884 30.6832C15.3782 28.9441 16.9655 27.495 18.8346 26.4648C20.8763 25.3394 23.3196 24.9586 26.5414 24.8254ZM30.1301 24.7658C30.54 24.7667 30.9622 24.7689 31.3962 24.7712C32.0077 24.7744 32.6427 24.7778 33.3 24.7778H46.7133C47.8449 24.7778 48.8963 24.7778 49.873 24.7834C49.0395 20.0942 44.9363 16.5333 40 16.5333C35.0699 16.5333 30.9708 20.0853 30.1301 24.7658Z",
    fill: "#747474"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.3206 33.602L57.5531 43.3534C53.7019 47.1983 50.6837 50.2115 48.0122 52.2464C45.2778 54.3293 42.6995 55.553 39.7138 55.553C36.728 55.553 34.1497 54.3293 31.4153 52.2464C28.7439 50.2115 25.7257 47.1984 21.8746 43.3535L12.5376 34.0319C12.0847 35.5157 11.9614 37.1354 12.0099 39.0172C12.0675 41.2535 12.3766 44.031 12.7718 47.5819L12.7893 47.7388C13.1122 50.6403 13.3659 52.9199 13.715 54.749C14.0711 56.6152 14.5487 58.1473 15.3893 59.52C16.7768 61.786 18.8009 63.5947 21.21 64.7212C22.6694 65.4037 24.2474 65.7084 26.1445 65.8557C28.0039 66 30.3011 66 33.2249 66H46.7744C49.6983 66 51.9961 66 53.8555 65.8557C55.7526 65.7084 57.3306 65.4037 58.79 64.7212C61.1991 63.5947 63.2232 61.786 64.6107 59.52C65.4513 58.1473 65.9289 56.6152 66.285 54.749C66.6341 52.92 66.8877 50.6407 67.2106 47.7396L67.2281 47.5821C67.6232 44.032 67.9325 41.2531 67.9901 39.0172C68.0434 36.9521 67.8897 35.2026 67.3206 33.602Z",
    fill: "#747474"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_1_2907",
    x: -22,
    y: -21,
    width: 124,
    height: 124,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1_2907"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1_2907",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_2907",
    x1: 3,
    y1: 4,
    x2: 77.0375,
    y2: 77.9625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_2907",
    x1: 40.4716,
    y1: 77.2913,
    x2: 113.589,
    y2: 1.56066,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_2907",
    x1: 40.4716,
    y1: 77.2913,
    x2: 113.589,
    y2: 1.56066,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrammar);
export default __webpack_public_path__ + "static/media/grammar.fb217066f1182c34de0eb5ef4d97be90.svg";
export { ForwardRef as ReactComponent };